export { default } from './capitalize';